import JoinDiscordInfoCard from "@core-components/JoinDiscordInfoCard";
import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack } from "@mantine/core";
import ClientDashboardTitle from "./components/ClientDashboardTitle";

const NeedHelp = () => {
  const { t } = useAppTranslation("pages.clientDashboard");

  return (
    <Stack align="flex-start">
      <ClientDashboardTitle
        icon={
          <AppThemeIcon className="size-8">
            <Icon.LifeBuoy />
          </AppThemeIcon>
        }
        label={t("needHelp.title")}
        subHeader={t("needHelp.subHeader")}
      />
      <div className="w-full sm:w-3/4 lg:w-1/2 xl:w-[500px]">
        <JoinDiscordInfoCard
          text={t("needHelp.discordText")}
          classNames={{
            root: "!bg-primary-client",
          }}
        />
      </div>
    </Stack>
  );
};

export default NeedHelp;
